import React, { createContext, useContext } from 'react';
import toast, { Toaster } from 'react-hot-toast';

// Create context
const ToastContext = createContext();

// Toast provider component
export const ToastProvider = ({ children }) => {
  // Toast functions with different styles
  const showSuccess = (message) => {
    toast.success(message, {
      duration: 5000,
      style: {
        background: '#10B981',
        color: '#fff',
      },
    });
  };

  const showError = (message) => {
    toast.error(message, {
      duration: 4000,
      style: {
        background: '#EF4444',
        color: '#fff',
      },
    });
  };

  const showInfo = (message) => {
    toast(message, {
      duration: 3000,
      style: {
        background: '#3B82F6',
        color: '#fff',
      },
      icon: 'ℹ️',
    });
  };

  const showWarning = (message) => {
    toast(message, {
      duration: 3500,
      style: {
        background: '#F59E0B',
        color: '#fff',
      },
      icon: '⚠️',
    });
  };

  // Context value
  const value = {
    showSuccess,
    showError,
    showInfo,
    showWarning,
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
      <Toaster 
        position="top-right"
        toastOptions={{
          className: '',
          style: {
            border: '1px solid #E5E7EB',
            padding: '16px',
            color: '#1F2937',
          },
        }}
      />
    </ToastContext.Provider>
  );
};

// Custom hook to use the toast context
export const useToast = () => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export default ToastContext;
